var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M47,11V6c0-1.105-0.895-2-2-2H3C1.895,4,1,4.895,1,6v5H47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "M45,43H15V11h32v30C47,42.105,46.105,43,45,43z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E86C60",
    cx: 4.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFD358",
    cx: 9.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#72C472",
    cx: 14.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    d: "M16,43H3c-1.105,0-2-0.895-2-2V11h15V43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    fill: "#B3B3B3",
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    fill: "#B3B3B3",
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    fill: "#B3B3B3",
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 32,
    fill: "#B3B3B3",
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 38,
    fill: "#B3B3B3",
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    fill: "#E86C60",
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    fill: "#EFD358",
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26,
    fill: "#FFFFFF",
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 32,
    fill: "#EFD358",
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38,
    fill: "#E86C60",
    width: 5,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.dde6b227ba62844e4bda72a903b63b53.svg";
export { ForwardRef as ReactComponent };